export default {"src":"/_next/static/media/star-disabled.85428cad.svg","height":37,"width":36,"blurWidth":0,"blurHeight":0};